import { IClassname } from '@/lib/shared/model/classname';

export const CoffeeMachine = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14249_7567)">
        <path
          d="M10.2494 30.6958V8.33225C10.2494 8.16279 10.3167 8.00027 10.4365 7.88044C10.5563 7.76061 10.7189 7.69329 10.8883 7.69329H29.4181C29.757 7.69329 30.0821 7.55866 30.3217 7.319C30.5614 7.07935 30.696 6.7543 30.696 6.41538V2.58163C30.696 2.2427 30.5614 1.91766 30.3217 1.678C30.0821 1.43835 29.757 1.30371 29.4181 1.30371H2.58187C2.24295 1.30371 1.9179 1.43835 1.67825 1.678C1.43859 1.91766 1.30396 2.2427 1.30396 2.58163V29.4179C1.30396 29.7568 1.43859 30.0818 1.67825 30.3215C1.9179 30.5612 2.24295 30.6958 2.58187 30.6958H29.4181"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9421 12.1661C25.8349 12.3788 25.6704 12.5573 25.4672 12.6815C25.264 12.8057 25.0301 12.8706 24.792 12.8689H17.4311C17.193 12.8706 16.9591 12.8057 16.7559 12.6815C16.5527 12.5573 16.3882 12.3788 16.281 12.1661L14.083 7.69336H28.1401L25.9421 12.1661Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3066 14.7216C24.3066 14.891 24.2393 15.0535 24.1194 15.1734C23.9996 15.2932 23.8371 15.3605 23.6676 15.3605H18.556C18.3865 15.3605 18.224 15.2932 18.1041 15.1734C17.9843 15.0535 17.917 14.891 17.917 14.7216V12.8047H24.3066V14.7216Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1948 20.4727H28.1402C28.8181 20.4727 29.4682 20.7419 29.9475 21.2212C30.4268 21.7006 30.6961 22.3506 30.6961 23.0285V25.5843"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7572 23.0283C15.6471 23.0289 15.539 23.0573 15.443 23.111C15.3469 23.1646 15.2659 23.2417 15.2077 23.335C15.1538 23.4283 15.1255 23.534 15.1255 23.6417C15.1255 23.7494 15.1538 23.8552 15.2077 23.9484L16.6006 26.7215C16.6414 26.8142 16.6632 26.9141 16.6645 27.0154V30.6958H26.8878V23.6673C26.8878 23.5834 26.8713 23.5003 26.8392 23.4228C26.8071 23.3452 26.76 23.2748 26.7007 23.2155C26.6413 23.1561 26.5709 23.1091 26.4934 23.077C26.4159 23.0448 26.3328 23.0283 26.2489 23.0283H15.7572Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.41562 1.30371V19.8335C6.41562 20.003 6.3483 20.1655 6.22848 20.2853C6.10865 20.4051 5.94613 20.4725 5.77666 20.4725H1.30396"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 5.1377H2.58187"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 8.97168H2.58187"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 12.8047H2.58187"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 16.6387H2.58187"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14249_7567">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
